// extracted by mini-css-extract-plugin
module.exports = {"barista":"_pixelart-module--barista--1UNCe","table1":"_pixelart-module--table1--15WWH"};